import apiClient from './apiClient';

/**
 * Dynamic Content Service
 * Handles admin API calls for support contacts, legal documents, FAQs, and emergency contacts
 */

export const dynamicContentService = {
  // Support Contacts
  async getSupportContacts() {
    const response = await apiClient.get('/api/v1/admin/settings/support-contacts');
    return response.data;
  },

  async updateSupportContacts(updates: Record<string, string>) {
    const response = await apiClient.put('/api/v1/admin/settings/support-contacts', updates);
    return response.data;
  },

  // Legal Documents
  async getLegalDocuments() {
    const response = await apiClient.get('/api/v1/admin/legal/documents');
    return response.data;
  },

  async getLegalDocument(id: string) {
    const response = await apiClient.get(`/api/v1/admin/legal/documents/${id}`);
    return response.data;
  },

  async createLegalDocument(data: any) {
    const response = await apiClient.post('/api/v1/admin/legal/documents', data);
    return response.data;
  },

  async updateLegalDocument(id: string, data: any) {
    const response = await apiClient.put(`/api/v1/admin/legal/documents/${id}`, data);
    return response.data;
  },

  async deleteLegalDocument(id: string) {
    const response = await apiClient.delete(`/api/v1/admin/legal/documents/${id}`);
    return response.data;
  },

  // FAQ Categories
  async getFAQCategories() {
    const response = await apiClient.get('/api/v1/admin/faq/categories');
    return response.data;
  },

  async createFAQCategory(data: any) {
    const response = await apiClient.post('/api/v1/admin/faq/categories', data);
    return response.data;
  },

  async updateFAQCategory(id: string, data: any) {
    const response = await apiClient.put(`/api/v1/admin/faq/categories/${id}`, data);
    return response.data;
  },

  async deleteFAQCategory(id: string) {
    const response = await apiClient.delete(`/api/v1/admin/faq/categories/${id}`);
    return response.data;
  },

  // FAQs
  async getFAQs() {
    const response = await apiClient.get('/api/v1/admin/faq');
    return response.data;
  },

  async createFAQ(data: any) {
    const response = await apiClient.post('/api/v1/admin/faq', data);
    return response.data;
  },

  async updateFAQ(id: string, data: any) {
    const response = await apiClient.put(`/api/v1/admin/faq/${id}`, data);
    return response.data;
  },

  async deleteFAQ(id: string) {
    const response = await apiClient.delete(`/api/v1/admin/faq/${id}`);
    return response.data;
  },

  // Emergency Contacts
  async getEmergencyContacts() {
    const response = await apiClient.get('/api/v1/admin/settings/emergency-contacts');
    return response.data;
  },

  async createEmergencyContact(data: any) {
    const response = await apiClient.post('/api/v1/admin/settings/emergency-contacts', data);
    return response.data;
  },

  async updateEmergencyContact(id: string, data: any) {
    const response = await apiClient.put(`/api/v1/admin/settings/emergency-contacts/${id}`, data);
    return response.data;
  },

  async deleteEmergencyContact(id: string) {
    const response = await apiClient.delete(`/api/v1/admin/settings/emergency-contacts/${id}`);
    return response.data;
  },

  // Beta/Invite Settings
  async getBetaSettings() {
    const response = await apiClient.get('/api/v1/admin/settings/beta-settings');
    return response.data;
  },

  async updateBetaSettings(settings: any) {
    const response = await apiClient.put('/api/v1/admin/settings/beta-settings', settings);
    return response.data;
  },
};

export default dynamicContentService;
